import { createIcon } from './icon-utils';

export const SmallTemplatePublishedIcon = createIcon({
  path: 'M7.5 13.0005V7.40049L5.8565 9.04399L5.15383 8.32099L8 5.47482L10.8462 8.32099L10.1435 9.04399L8.5 7.40049V13.0005H7.5ZM3 6.01332V4.20565C3 3.86888 3.11667 3.58382 3.35 3.35049C3.58333 3.11715 3.86839 3.00049 4.20517 3.00049H11.7948C12.1316 3.00049 12.4167 3.11715 12.65 3.35049C12.8833 3.58382 13 3.86888 13 4.20565V6.01332H12V4.20565C12 4.15432 11.9786 4.10732 11.9358 4.06465C11.8932 4.02188 11.8462 4.00049 11.7948 4.00049H4.20517C4.15383 4.00049 4.10683 4.02188 4.06417 4.06465C4.02139 4.10732 4 4.15432 4 4.20565V6.01332H3Z',
  style: { height: 16, width: 16 },
  viewBox: '0 0 16 16',
});
